// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 35px 20px;
  margin: 0;
  border-radius: 12px;
}
.container .cross-icon {
  z-index: 5;
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 22px;
  height: 22px;
  padding: 0px;
  z-index: 99;
}
.container .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.container .icon {
  width: 90px;
  height: 90px;
  margin-bottom: 25px;
}

.title {
  font-family: var(--ion-font-family);
  font-weight: 700;
  font-size: 30px;
  line-height: 100%;
  text-align: center;
  vertical-align: middle;
  color: var(--color-black);
  margin-bottom: 40px;
}

.info {
  font-family: var(--ion-font-family);
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--color-black);
}

.button {
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  padding-top: 20px;
}
.button:last-child {
  margin-bottom: 0;
}
.button_main, .button_close {
  font-family: var(--ion-font-family);
  font-weight: 700;
  font-size: 16px;
  line-height: 130%;
  text-transform: none;
}

.eintracht {
  background: #121212;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.eintracht .title, .eintracht .info {
  font-family: AppFontEintrachtOFCSans;
  color: #ffffff;
  text-transform: uppercase;
}
.eintracht .button_close {
  color: #ffffff;
  background: transparent;
  border: 1px solid #E30613;
}`, "",{"version":3,"sources":["webpack://./src/app/components/info-modal/info-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;AACF;AAAE;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAEF;AADE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAGH;AAGE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AADJ;;AAKA;EACE,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,mCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAFF;;AAMA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AAHF;AAKE;EACE,gBAAA;AAHJ;AAME;EACE,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAJJ;;AAOA;EACE,mBAAA;EACA,4BAAA;EACA,6BAAA;AAJF;AAKE;EACE,oCAAA;EACA,cAAA;EACA,yBAAA;AAHJ;AAME;EACI,cAAA;EACA,uBAAA;EACA,yBAAA;AAJN","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 35px 20px;\n  margin: 0;\n  border-radius: 12px;\n  .cross-icon {\n\t\tz-index: 5;\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t\t// &:hover {\n\t\t// \tbackground: #f2dbd9;\n\t\t// }\n\t}\n  .icon {\n    width: 90px;\n    height: 90px;\n    margin-bottom: 25px;\n  }\n}\n\n.title {\n  font-family: var(--ion-font-family);\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 100%;\n  text-align: center;\n  vertical-align: middle;\n  color: var(--color-black);\n  margin-bottom: 40px;\n}\n\n.info {\n  font-family: var(--ion-font-family);\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.02em;\n  text-align: center;\n  color: var(--color-black);\n\n}\n\n.button {\n  height: 50px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n  padding-top: 20px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &_main, &_close  {\n    font-family: var(--ion-font-family);\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 130%;\n    text-transform: none;\n  }\n}\n.eintracht {\n  background: #121212;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  .title, .info {\n    font-family: AppFontEintrachtOFCSans;\n    color: #ffffff;\n    text-transform: uppercase;\n  }\n\n  .button_close {\n      color: #ffffff;\n      background: transparent;\n      border: 1px solid #E30613;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
